export const OPTIMIZATION_BOUNDS = {
  distanceBetweenPoles: { min: 15, max: 108, step: 1.0 },
  heightOfTheLightPoint: { min: 3, max: 18 },
  overhang: { min: -10, max: 10, step: 0.25 },
  tiltOfTheLuminaire: { min: 0, max: 15.0 },
  maintenanceFactor: { min: 0.1, max: 1, step: 0.01, precision: 2 },
} as const;
